export const PropertiesStats = {
  // Aggregated Stats
  GET_PROPERTIES_AGGREGATED_STATS: "GET_PROPERTIES_AGGREGATED_STATS",
  GET_PROPERTIES_AGGREGATED_STATS_SUCCESS: "GET_PROPERTIES_AGGREGATED_STATS_SUCCESS",
  
  // Rent Payments
  GET_RENT_PAYMENTS: "GET_RENT_PAYMENTS",
  GET_RENT_PAYMENTS_SUCCESS: "GET_RENT_PAYMENTS_SUCCESS",
  
  // Utility Bill Payments
  GET_UTILITY_BILL_PAYMENTS: "GET_UTILITY_BILL_PAYMENTS",
  GET_UTILITY_BILL_PAYMENTS_SUCCESS: "GET_UTILITY_BILL_PAYMENTS_SUCCESS",
  PAY_UTILITY_BILL: "PAY_UTILITY_BILL", // ✅ ADD missing action
  PAY_UTILITY_BILL_SUCCESS: "PAY_UTILITY_BILL_SUCCESS", // ✅ ADD missing action
  UPLOAD_RECEIPT: "UPLOAD_RECEIPT", // ✅ ADD missing action
  UPLOAD_RECEIPT_SUCCESS: "UPLOAD_RECEIPT_SUCCESS", // ✅ ADD missing action
  
  // ✅ NEW: Utility Bill Management Actions
  MARK_UTILITY_BILL_AS_PAID: "MARK_UTILITY_BILL_AS_PAID",
  MARK_UTILITY_BILL_AS_PAID_SUCCESS: "MARK_UTILITY_BILL_AS_PAID_SUCCESS",
  UPLOAD_UTILITY_BILL_RECEIPT: "UPLOAD_UTILITY_BILL_RECEIPT",
  UPLOAD_UTILITY_BILL_RECEIPT_SUCCESS: "UPLOAD_UTILITY_BILL_RECEIPT_SUCCESS",
  RUN_UTILITY_BILLS_BOT: "RUN_UTILITY_BILLS_BOT",
  
  // Property Files
  GET_PROPERTY_FILES: "GET_PROPERTY_FILES",
  GET_PROPERTY_FILES_SUCCESS: "GET_PROPERTY_FILES_SUCCESS",
  
  // Property Calendar Events
  GET_PROPERTY_CALENDAR: "GET_PROPERTY_CALENDAR",
  GET_PROPERTY_CALENDAR_SUCCESS: "GET_PROPERTY_CALENDAR_SUCCESS",
  
  // Property Chats
  GET_PROPERTY_CHATS: "GET_PROPERTY_CHATS",
  GET_PROPERTY_CHATS_SUCCESS: "GET_PROPERTY_CHATS_SUCCESS",
  
  // Property Queries
  GET_PROPERTY_QUERIES: "GET_PROPERTY_QUERIES",
  GET_PROPERTY_QUERIES_SUCCESS: "GET_PROPERTY_QUERIES_SUCCESS",
  
  // Property Invitations
  GET_PROPERTY_INVITATIONS: "GET_PROPERTY_INVITATIONS",
  GET_PROPERTY_INVITATIONS_SUCCESS: "GET_PROPERTY_INVITATIONS_SUCCESS",
  
  // Landlord Tenant Invitations
  GET_LANDLORD_TENANT_INVITATIONS: "GET_LANDLORD_TENANT_INVITATIONS",
  GET_LANDLORD_TENANT_INVITATIONS_SUCCESS: "GET_LANDLORD_TENANT_INVITATIONS_SUCCESS",
  
  // Shared Management Invitations
  GET_SHARED_MANAGEMENT_INVITATIONS: "GET_SHARED_MANAGEMENT_INVITATIONS",
  GET_SHARED_MANAGEMENT_INVITATIONS_SUCCESS: "GET_SHARED_MANAGEMENT_INVITATIONS_SUCCESS",
  
  // Add missing folders actions
  GET_PROPERTY_FOLDERS: "GET_PROPERTY_FOLDERS",
  GET_PROPERTY_FOLDERS_SUCCESS: "GET_PROPERTY_FOLDERS_SUCCESS",
};

// Aggregated Stats Actions
export const getPropertiesAggregatedStats = (payload) => ({
  type: PropertiesStats.GET_PROPERTIES_AGGREGATED_STATS,
  payload,
});

// Rent Payments Actions
export const getRentPayments = (payload) => ({
  type: PropertiesStats.GET_RENT_PAYMENTS,
  payload,
});

// Utility Bill Payments Actions
export const getUtilityBillPayments = (payload) => ({
  type: PropertiesStats.GET_UTILITY_BILL_PAYMENTS,
  payload,
});

// ✅ ADD: Missing utility bill actions
export const payUtilityBill = (payload) => ({
  type: PropertiesStats.PAY_UTILITY_BILL,
  payload,
});

export const uploadReceipt = (payload) => ({
  type: PropertiesStats.UPLOAD_RECEIPT,
  payload,
});

// Property Files Actions
export const getPropertyFiles = (payload) => ({
  type: PropertiesStats.GET_PROPERTY_FILES,
  payload,
});

// Property Calendar Actions
export const getPropertyCalendar = (payload) => ({
  type: PropertiesStats.GET_PROPERTY_CALENDAR,
  payload,
});

// Property Chats Actions
export const getPropertyChats = (payload) => ({
  type: PropertiesStats.GET_PROPERTY_CHATS,
  payload,
});

// Property Queries Actions
export const getPropertyQueries = (payload) => ({
  type: PropertiesStats.GET_PROPERTY_QUERIES,
  payload,
});

// Property Invitations Actions
export const getPropertyInvitations = (payload) => ({
  type: PropertiesStats.GET_PROPERTY_INVITATIONS,
  payload,
});

// Landlord Tenant Invitations Actions
export const getLandlordTenantInvitations = (payload) => ({
  type: PropertiesStats.GET_LANDLORD_TENANT_INVITATIONS,
  payload,
});

// Shared Management Invitations Actions
export const getSharedManagementInvitations = (payload) => ({
  type: PropertiesStats.GET_SHARED_MANAGEMENT_INVITATIONS,
  payload,
});

// Add missing action creator
export const getPropertyFolders = (payload) => ({
  type: PropertiesStats.GET_PROPERTY_FOLDERS,
  payload,
});

// ✅ NEW: Utility Bill Management Actions
export const markUtilityBillAsPaid = (payload) => ({
  type: PropertiesStats.MARK_UTILITY_BILL_AS_PAID,
  payload,
});

export const uploadUtilityBillReceipt = (payload) => ({
  type: PropertiesStats.UPLOAD_UTILITY_BILL_RECEIPT,
  payload,
});

export const runUtilityBillsBot = (payload) => ({
  type: PropertiesStats.RUN_UTILITY_BILLS_BOT,
  payload,
});